import { useState } from 'react';
import { css } from '@emotion/react';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Button, Text, TextLink } from '@frontend/design-system';

export const CommunicationAnalyticsReleaseBanner = () => {
  const { t } = useTranslation('analytics');
  const navigate = useNavigate();

  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  const onCTAClick = () => {
    navigate({
      to: '/analytics/communication',
      search: (prev: any) => ({ ...prev }),
    });
  };

  const title = t('An improved version of Phone analytics is now available in the Communication tab');
  return (
    <div css={styles.wrapper} data-testid='demo-data-banner'>
      <Icon name='info-filled' />
      <div className='note-wrapper'>
        <div style={{ flexGrow: 1 }}>
          <Text weight='bold'>{title}</Text>
        </div>
        <TextLink onClick={onCTAClick} trackingId={'communication-analytics-release-banner'} weight='bold'>
          View
        </TextLink>
        <Button
          css={styles.dismissButtonStyle}
          variant='secondary'
          iconName='x'
          onClick={() => setDismissed(true)}
          aria-label='Dismiss'
          trackingId='communication-analytics-release-banner-dismiss-btn'
          data-testid='communication-analytics-release-banner-dismiss-btn'
        />
      </div>
    </div>
  );
};

const styles = {
  wrapper: css`
    align-items: flex-start;
    background-color: ${theme.colors.primary5};
    box-shadow: ${theme.shadows.light};
    display: flex;
    gap: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(0.5)};
    padding: ${theme.spacing(2, 3)};
    position: sticky;
    top: 0;
    z-index: 1;

    @media screen and (min-width: ${breakpoints.small.max}px) {
      align-items: center;
    }

    .note-wrapper {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      gap: ${theme.spacing(2)};

      @media screen and (min-width: ${breakpoints.small.max}px) {
        align-items: center;
        flex-direction: row;
      }
    }
  `,
  dismissButtonStyle: css`
    @container (max-width: ${breakpoints.small.min}px) {
      position: absolute;
      top: 0;
      right: 0;
    }
  `,
};
